const changeNameUtil = async (newName) => {
  try {
    const body = { newName };
    const res = await fetch("/api/dashboard/accounts/name", {
      method: "PUT",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(body),
    });
    const parseRes = await res.json();
    return parseRes;
  } catch (error) {
    console.error(error.message);
  }
};

export default changeNameUtil;
